<template>
    <div>
      <h2>404</h2>
    </div>
</template>



<script>

export default {
  name:"404",
    components:{
    },   
  data () {
    return {
    }
  },
  methods : {
  }
};
</script>
